module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.48958in",
      "height": "3.71875in"
    },
    attrs: {
      "alt": "C:\\Users\\ViralWebbs\\Pictures\\FP\\1.jpg",
      "src": "Images/file0.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\ViralWebbs\\Pictures\\FP\\1.jpg")])]), _vm._v(" "), _c('p', [_vm._v("Eileen Ballman was raised in Cheshire, Connecticut. She was the middle child in her large Irish Catholic family of eight. She’s learned about life through her three distinct careers in sales, interior design, and teaching. After joining the military in the mid-seventies, she landed on the West Coast where she got married, raised her children, and lived joyfully for 22 years between Washington and Oregon. She and her family moved to North Carolina in 2000, and after retiring from teaching in 2012, she now resides in St Augustine, Florida, with her husband, Dave. She has two sons, Jake and Josh, and has a host of ‘everywoman’ friends who keep her happy and sane in her beloved beach town.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0